module.exports = __webpack_public_path__ + "img/dep_personalcare@2x.f0e8f451.png";